<script>
import XLSX from "xlsx";
import { cloneDeep } from "lodash";
import Layout from "@/router/layouts/main";
export default {
    page: {
        title: "Excel Uploading",
    },
    components: {
        Layout,
    },
    data() {
        return {
            uploadArray: [],
            excelList: [],
            unitList: [],
            categoryList: [],
            doneFiltering: false,
        };
    },
    created() {},
    methods: {
        renderExcel(event) {
            this.file = event.target.files ? event.target.files[0] : null;
            if (this.file) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: "binary" });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws);
                    const excellist = [];
                    for (var i = 0; i < data.length; i++) {
                        excellist.push(data[i]);
                    }
                    this.excelList = excellist;
                };
                reader.readAsBinaryString(this.file);
            }
        },
        applyFiltering() {
            var excelList = cloneDeep(this.excelList);
            this.doneFiltering = true;
            excelList.forEach((item) => {
                for(var key in item){
                    let trimmedKey = key.toLowerCase().trim().replace(/\s+/g,'');
                    if(trimmedKey == 'itemname'){
                        item.itemName = item[key];
                    }
                    if(trimmedKey == 'specifications'){
                        item.description = item[key];
                    }
                    if(trimmedKey == 'unit'){
                        item.unitId = parseInt(item[key]);
                    }
                    if(trimmedKey == 'itemcategory'){
                        item.itemCategoryId = parseInt(item[key]);
                    }
                    if(trimmedKey == 'unitcost'){
                        item.unitCost = this.getExactAmt(item[key]);
                    }
                    if(trimmedKey == 'type'){
                        item.type = item[key] ?? 'NON-CSE';
                        item.inDbm = item[key] == 'CSE' ? true : false;
                    }
                    if(trimmedKey == 'sub-type'){
                        item.subType = item[key];
                    }
                    // if(trimmedKey == 'indbm'){
                    //     item.inDbm = item[key] == 1 ? true : false;
                    // }
                    if(trimmedKey == 'stockid'){
                        item.stockId = item[key];
                    }
                    delete item[key];
                }
                // delete item['Item Name'];
                // delete item['Specifications'];
                // delete item['Unit'];
                // delete item['Item Category'];
                // delete item['Unit Cost'];
                // delete item['Type']
                // delete item['Sub-type']
                // delete item['In DBM']
                item.isProcurable = true;
                item.image = "";
                item.thumbnail = "";
                item.year = this.$store.state.data.cycle;
                item.campusId = this.$store.state.data.selectedCampus.id;
            });
            this.excelList = excelList;
        },
        async uploadExcel() {
            await this.$store
                .dispatch("item/CreateMultipleItem", this.excelList)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error")
                    }
                    this.doneFiltering = false;
                    this.showToast("Successfully created!", "success")
                })
                .catch((err) => {
                    this.showToast(err, "error")
                });
        },
        ExcelDateToJSDate(serial) {
            var utc_days  = Math.floor(serial - 25569);
            var utc_value = utc_days * 86400;                                        
            var date_info = new Date(utc_value * 1000);

            var fractional_day = serial - Math.floor(serial) + 0.0000001;

            var total_seconds = Math.floor(86400 * fractional_day);

            var seconds = total_seconds % 60;

            total_seconds -= seconds;

            var hours = Math.floor(total_seconds / (60 * 60));
            var minutes = Math.floor(total_seconds / 60) % 60;

            return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
        },
        changeParams(){
            this.excelList = [];
            this.doneFiltering = false;
            let doc = document.getElementById('inputGroupFile04');
            doc.value = null;
        }
    },
};
</script>
<template>
    <Layout @changeCampus="changeParams" @changeCycle="changeParams">
        <div class="d-flex justify-content-center">
            <div class="my-3 px-2 container">
                <h4>Excel Uploading</h4>
                <form class="needs-validation mb-4" ref="usForm">
                    <div class="input-group">
                        <input
                            type="file"
                            class="form-control"
                            id="inputGroupFile04"
                            aria-describedby="inputGroupFileAddon04"
                            aria-label="Upload"
                            @change="renderExcel"
                        />
                        <button
                            class="btn btn-primary"
                            type="button"
                            id="inputGroupFileAddon04"
                            @click="uploadExcel"
                            v-if="doneFiltering"
                        >
                            Upload
                        </button>
                    </div>
                </form>
                <div v-if="excelList.length > 0">
                    <div class="row">
                        <div class="col-md-6"><h4>Excel Data</h4></div>
                        <div class="col-md-6 text-right">
                            <button
                                class="btn btn-primary btn-sm"
                                type="button"
                                @click="applyFiltering"
                                v-if="!doneFiltering"
                            >
                                Apply More Filtering
                            </button>
                        </div>
                    </div>

                    <div class="p-3 text-dark">
                        <div>[</div>
                        <template v-for="(x, indexX) in excelList">
                            <div :key="indexX" class="ms-4">
                                <div>{</div>
                                <template v-for="(y, value, indexY) in x">
                                    <div :key="indexX + indexY" class="ms-4">
                                        <b>"{{ value }}" :</b>
                                        <span class="ms-2">"{{ y }}"</span>
                                    </div>
                                </template>
                                <div>},</div>
                            </div>
                        </template>
                        <div>]</div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>